
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay/[shortname]",
      function () {
        return require("private-next-pages/pay/[shortname].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay/[shortname]"])
      });
    }
  